import {option, Option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import Bill from "../../model/bill/Bill";

/**
 * Get bill by job identifier.
 * @param {string} jobId Job identifier.
 * @param {RootState} state State of the redux.
 */
export function getBillByJobId(jobId: string, state: RootState): Option<Bill> {
	const bill = state.bill.billsByJobIdMap[jobId];
	return option(bill);
}
